/**
 * Globo Locale URL Fix
 * Prepends the current locale prefix (e.g., /id) to product links
 * rendered by Globo filter, since Globo's template engine doesn't
 * include Shopify's locale-aware routing.
 */
(function () {
    function getLocalePrefix() {
        // Extract locale prefix from current URL path
        // e.g., /id/collections/all → "/id"
        var match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
        if (match) {
            return '/' + match[1];
        }
        return '';
    }

    function fixProductUrls(root) {
        var prefix = getLocalePrefix();
        if (!prefix) return; // No locale prefix, nothing to fix

        var container = root || document.querySelector('#gf-products') || document;
        var links = container.querySelectorAll('a[href]');

        links.forEach(function (link) {
            var href = link.getAttribute('href');
            if (!href) return;

            // Only fix product-related paths that don't already have the locale prefix
            if (
                (href.startsWith('/products/') || href.startsWith('/collections/')) &&
                !href.startsWith(prefix + '/')
            ) {
                link.setAttribute('href', prefix + href);
            }
        });

        // Also fix data-product-url and data-url attributes
        var dataUrlElements = container.querySelectorAll('[data-product-url], [data-url]');
        dataUrlElements.forEach(function (el) {
            ['data-product-url', 'data-url'].forEach(function (attr) {
                var val = el.getAttribute(attr);
                if (!val) return;
                if (
                    (val.startsWith('/products/') || val.startsWith('/collections/')) &&
                    !val.startsWith(prefix + '/')
                ) {
                    el.setAttribute(attr, prefix + val);
                }
            });
        });
    }

    // Initial fix on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { fixProductUrls(); });
    } else {
        fixProductUrls();
    }

    // Re-fix after Globo filter re-renders
    window.addEventListener('globoFilterRenderCompleted', function () {
        setTimeout(function () { fixProductUrls(); }, 300);
    });

    // Observe DOM for dynamically added product cards
    var observer = new MutationObserver(function (mutations) {
        var hasNewLinks = mutations.some(function (m) {
            return m.addedNodes.length > 0;
        });
        if (hasNewLinks) {
            // Debounce to avoid excessive processing
            clearTimeout(observer._timer);
            observer._timer = setTimeout(function () { fixProductUrls(); }, 200);
        }
    });

    var grid = document.getElementById('gf-products') ||
        document.querySelector('.collection') ||
        document.documentElement;
    observer.observe(grid, { childList: true, subtree: true });
})();
